import React from 'react';
import { Helmet } from 'react-helmet';
import { DomainService } from '../../services/domain';

export const RcmDomainConfig = (): JSX.Element => {
  const config = {
    domainMapping: DomainService.getDomainMapping(),
    domainToUrlMapping: DomainService.getDomainToUrlMapping(),
  };

  return (
    <Helmet>
      <meta name="domain-config" content={JSON.stringify(config)} />
    </Helmet>
  );
};
